import { render, staticRenderFns } from "./RevenueStreamsTabs.vue?vue&type=template&id=46dcfd18&scoped=true"
import script from "./RevenueStreamsTabs.vue?vue&type=script&lang=js"
export * from "./RevenueStreamsTabs.vue?vue&type=script&lang=js"
import style0 from "./RevenueStreamsTabs.vue?vue&type=style&index=0&id=46dcfd18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dcfd18",
  null
  
)

export default component.exports